import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, getElementCenterPos, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, openContent } from '@nu-art/thunderstorm-frontend';
import { exists } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { ModuleFE_Expression } from '@app/hcs-frontend';
import { Window_ExpressionEditor } from '@app/hcs-frontend/ui/_editors/expression/Window_ExpressionEditor/Window_ExpressionEditor';
import { ExpressionOutput_Boolean, ExpressionType_GeneralFunction } from '@app/hcs-shared';
import { AccessLevel } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { Dialog_AssignOrderExpression } from '../../Page_OrderEditor/presenters/editor/data-renderers/order-rules-editor/Dialog_AssignOrderExpression.js';
import './Renderer_OrderExpressionIndicator.scss';
export class Renderer_OrderExpressionIndicator extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.orderId = nextProps.orderId;
        state.editMode = nextProps.editMode;
        state.expressionId = nextProps.expressionId;
        return state;
    }
    getExpressionId = () => this.props.expressionId;
    getExpressionLabel = () => {
        const expressionId = this.getExpressionId();
        if (!expressionId)
            return 'No expression';
        const expression = ModuleFE_Expression.cache.unique(expressionId);
        return expression?.label ?? 'Unknown expression';
    };
    openExpressionEditor = () => {
        const expressionId = this.getExpressionId();
        if (!expressionId)
            return;
        const canEdit = ModuleFE_Expression.permissions.collection.edit.getAccessLevel() === AccessLevel.HasAccess;
        Window_ExpressionEditor.show({
            expressionId,
            editMode: canEdit,
            editorConfig: {
                label: true,
                terms: true,
                outputType: false,
                output: true,
            },
        });
    };
    openCreateExpression = () => {
        const canEdit = ModuleFE_Expression.permissions.collection.edit.getAccessLevel() === AccessLevel.HasAccess;
        Window_ExpressionEditor.show({
            editMode: canEdit,
            editorConfig: {
                label: true,
                terms: true,
                outputType: false,
                output: true,
            },
            initialData: {
                expressionType: ExpressionType_GeneralFunction.dbKey,
                outputType: ExpressionOutput_Boolean,
                tagGroups: [],
            },
            onSaved: async (saved) => {
                this.props.onExpressionChange?.(saved._id);
            },
        });
    };
    openAssignExpressionDialog = () => {
        Dialog_AssignOrderExpression.show({
            expressionId: this.getExpressionId(),
            onSave: async (expressionId) => this.props.onExpressionChange?.(expressionId),
        });
    };
    openExpressionMenu = (e) => {
        e.stopPropagation();
        const model = {
            id: 'pop-up__order-expression-menu',
            originPos: getElementCenterPos(e.currentTarget),
            modalPos: { x: -1, y: 1 },
            xAxisAnchor: 'right',
            offset: { x: 8 },
            content: () => _jsxs(_Fragment, { children: [_jsx(Button, { variant: 'text', onClick: () => {
                            this.openAssignExpressionDialog();
                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: "Assign existing expression" }), _jsx(Button, { variant: 'text', onClick: () => {
                            this.openCreateExpression();
                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: "Create new expression" }), exists(this.getExpressionId()) &&
                        _jsx(Button, { variant: 'text', onClick: () => {
                                this.props.onExpressionChange?.(undefined);
                                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                            }, children: "Clear" })] }),
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    render() {
        const expressionId = this.getExpressionId();
        const expressionLabel = this.getExpressionLabel();
        if (this.state.editMode) {
            return _jsxs("div", { className: 'order-expression-indicator', children: [exists(expressionId) && _jsxs(_Fragment, { children: [_jsx(ICONS.expressions.component, { className: 'order-expression-indicator__icon', ...openContent.tooltip.top('tooltip__order-expression', expressionLabel, { offset: 6 }), onClick: (e) => {
                                    e.stopPropagation();
                                    this.openExpressionEditor();
                                } }), _jsx("span", { className: 'order-expression-indicator__label', children: expressionLabel })] }), _jsx(ICONS.more.component, { className: 'order-expression-indicator__menu', onClick: this.openExpressionMenu })] });
        }
        if (!exists(expressionId))
            return null;
        return _jsxs("div", { className: 'order-expression-indicator', children: [_jsx(ICONS.expressions.component, { className: 'order-expression-indicator__icon order-expression-indicator__icon--view', ...openContent.tooltip.top('tooltip__order-expression', expressionLabel, { offset: 6 }), onClick: (e) => {
                        e.stopPropagation();
                        this.openExpressionEditor();
                    } }), _jsx("span", { className: 'order-expression-indicator__label', children: expressionLabel })] });
    }
}
//# sourceMappingURL=Renderer_OrderExpressionIndicator.js.map